namespace Nobox.EmailQueue {
    export interface EmailQueuePerTenantRow {
        MailId?: number;
        TenantId?: number;
        Uid?: string;
        Subject?: string;
        Body?: string;
        SerializedMessage?: number[];
        MailFrom?: string;
        MailTo?: string;
        ReplyTo?: string;
        Cc?: string;
        Bcc?: string;
        Attachments?: string;
        Priority?: Web.Modules.Attr.Enum.EmailQueuePriority;
        Status?: Web.Modules.Attr.Enum.EmailQueueStatus;
        RetryCount?: number;
        ErrorMessage?: string;
        LockExpiration?: string;
        SentDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        Settings?: string;
        Process?: number;
        AccountId?: number;
        AccountName?: string;
        IsSMTP?: string;
        Host?: string;
        Port?: string;
        UseSSL?: number;
        From?: string;
        Username?: string;
        Password?: string;
        Provider?: string;
        BaseUrlApi?: string;
        EndpointApi?: string;
        KeyApi?: string;
        FromApi?: string;
    }

    export namespace EmailQueuePerTenantRow {
        export const idProperty = 'MailId';
        export const nameProperty = 'Subject';
        export const localTextPrefix = 'EmailQueue.EmailQueuePerTenant';
        export const lookupKey = 'EmailQueue.EmailQueuePerTenant';

        export function getLookup(): Q.Lookup<EmailQueuePerTenantRow> {
            return Q.getLookup<EmailQueuePerTenantRow>('EmailQueue.EmailQueuePerTenant');
        }
        export const deletePermission = 'EmailQueuePerTenant:Delete';
        export const insertPermission = 'EmailQueuePerTenant:Modify';
        export const readPermission = 'EmailQueuePerTenant:View';
        export const updatePermission = 'EmailQueuePerTenant:Modify';

        export declare const enum Fields {
            MailId = "MailId",
            TenantId = "TenantId",
            Uid = "Uid",
            Subject = "Subject",
            Body = "Body",
            SerializedMessage = "SerializedMessage",
            MailFrom = "MailFrom",
            MailTo = "MailTo",
            ReplyTo = "ReplyTo",
            Cc = "Cc",
            Bcc = "Bcc",
            Attachments = "Attachments",
            Priority = "Priority",
            Status = "Status",
            RetryCount = "RetryCount",
            ErrorMessage = "ErrorMessage",
            LockExpiration = "LockExpiration",
            SentDate = "SentDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            Settings = "Settings",
            Process = "Process",
            AccountId = "AccountId",
            AccountName = "AccountName",
            IsSMTP = "IsSMTP",
            Host = "Host",
            Port = "Port",
            UseSSL = "UseSSL",
            From = "From",
            Username = "Username",
            Password = "Password",
            Provider = "Provider",
            BaseUrlApi = "BaseUrlApi",
            EndpointApi = "EndpointApi",
            KeyApi = "KeyApi",
            FromApi = "FromApi"
        }
    }
}
